import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import EditorViewer from "../../../Common/EditorViewer";

const EditorRules = () => {
    const LoginStates = useSelector(state => state.login);
    const [rulesData, setRulesData] = useState(null);
    useEffect(() => {
        const root = document.getElementById('root');
        if (root) {
            root.style.minWidth = 'unset';
        }
    }, []);
    useEffect(() => {
        if (!LoginStates.userId) return;
        getEditorRules();
    }, [LoginStates]);
    
    const getEditorRules = async () => {
        const response = await fetch('api/Edit/GetEditorRules', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
        });
        if (response.status === 200) {
            const result = await response.json();
            if(result.data) {
                const data = result.data[0];
                const item = {
                    docId: data.docID,
                    title: data.title,
                    tag: data.tag !== "" ? data.tag.includes("[") ? JSON.parse(data.tag) : data.tag.split(",") : [],
                    relationInfo: data.relationInfo !== "" ? JSON.parse(data.relationInfo) : [],
                    data: data.contentJson !== "" ? JSON.parse(data.contentJson).data : {},
                    updateDate: data.updateDateTime,
                }
                setRulesData(item);
            }
        }
    }

    return (
        <div style={{padding: "80px 0 0px", overflowY: "scroll"}}>
            <div className={"title-section"}>
                <p>{rulesData?.title || ""}</p>
            </div>
            {rulesData && <EditorViewer ViewMode={true} editorData={rulesData} folderName={'template'} docId={rulesData.docId} />}
        </div>
    )
}
export default EditorRules;